import { render, staticRenderFns } from "./OutputContributions.vue?vue&type=template&id=0d252848"
import script from "./OutputContributions.vue?vue&type=script&lang=js"
export * from "./OutputContributions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports